import * as XLSX from "xlsx";

export const uploadXLSX = (
  file: File
): Promise<{ seq: string | number; delivery_info: string | number }[]> => {
  return new Promise((resolve, reject) => {
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      if (!e.target?.result) return reject("파일을 읽을 수 없습니다.");

      if (!file.name.includes("xlsx")) {
        alert("xlsx 파일만 첨부가능합니다.");
        return reject(null);
      }

      const data = new Uint8Array(e.target.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });

      const firstWorksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData: string[][] = XLSX.utils.sheet_to_json(firstWorksheet, {
        header: 1,
      });

      if (jsonData.length === 0) {
        alert("xlxs에서 읽을 수 있는 데이터가 없습니다.");
        return reject(null);
      }

      const header: string[] = jsonData[0];
      const idx_메모1 = header.indexOf("메모1");
      const idx_운송장번호 = header.indexOf("운송장번호");

      if (idx_메모1 === -1 || idx_운송장번호 === -1) {
        alert("[형식 불일치] '메모1'과 '운송장번호'가 있는지 확인해주세요.");
        return reject(null);
      }

      // 메모1, 운송장번호 추출 [][]
      const result = jsonData
        .map((row) => {
          return [row[idx_메모1], row[idx_운송장번호]];
        })
        .filter((values, idx) => idx !== 0 && values[0] && values[1]);

      // 형식 변환 [{}]
      const realResult = result.map((row) => {
        return { seq: row[0], delivery_info: row[1], order_status: "배송준비" };
      });

      resolve(realResult);
    };

    reader.onerror = () => reject("파일 읽기 실패");
    reader.readAsArrayBuffer(file);
  });
};
